import React from 'react'
import classnames from 'classnames'
import {
  IconCheckCircle,
  IconInfoCircle,
  IconTimesCircle
} from 'src/Components/Icon'
import Text from 'src/Components/Text'

import styles from './ProCon.module.scss'

const LI = ({ className, color, icon: Icon, iconColor, children }) => (
  <li className={classnames(className, styles.li)}>
    <Text color={iconColor} element='span' className={styles.iconCol}>
      <Icon />
    </Text>
    <Text size='s' color={color} className={styles.textCol}>
      {children}
    </Text>
  </li>
)

LI.defaultProps = {
  color: 'quiet'
}

export const Con = props => (
  <LI icon={IconTimesCircle} iconColor='danger' {...props} />
)

export const Info = props => (
  <LI icon={IconInfoCircle} iconColor='warning' {...props} />
)

export const Pro = props => (
  <LI icon={IconCheckCircle} iconColor='positive' {...props} />
)

export const ProConList = props => <ul {...props} />

ProConList.Pro = Pro
ProConList.Con = Con
ProConList.Info = Info

export default ProConList
